// removed by extract-text-webpack-plugin
module.exports = {"encryption":"_3t6kx06z7H4UomqxtZoKsH","noBottomMargin":"C2A8u4Y-IjMwcxeYpVPh_","securityLock":"_3RID2_4xXlosCSIj2O-fVV","heading":"_2YKvdPvFBEJyUx7mwkSdLh","subHeading":"ftoVlhphEMoCU67Gjhv1n"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Heading/style.scss
// module id = 2151
// module chunks = 1